jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	  //  $( document ).on( "variant:changed", function( evt ) {
	  //    console.log( evt.currentVariant );
	  //    // $('[data-variant-toggle]').hide(0);
	  //    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	  //  });

// $( document ).on( "variant:changed", function( evt ) {
//   console.log(evt.currentVariant.id)
//   document.querySelector(`.main_product_hiddens select[data-groups-pr-sl] option[value="${evt.currentVariant.id}"]`).selected = true;
// });
  
});